module.exports = __webpack_public_path__ + "static/media/sca-award.06bed33b.png";